var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrideyeIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 0C3.4585 0 0.666504 4 0.666504 4C0.666504 4 3.4585 8 7.99984 8C12.5412 8 15.3332 4 15.3332 4C15.3332 4 12.5412 0 7.99984 0ZM7.99984 6.66667C5.37117 6.66667 3.3825 5.01067 2.41317 4C3.1065 3.27667 4.32184 2.22867 5.9165 1.68667C5.54125 2.15369 5.33559 2.73423 5.33317 3.33333C5.33317 4.80667 6.5265 6 7.99984 6C9.47317 6 10.6665 4.80667 10.6665 3.33333C10.6665 2.70867 10.4432 2.142 10.0832 1.68667C11.6785 2.22867 12.8938 3.27733 13.5858 4C12.6152 5.012 10.6272 6.66667 7.99917 6.66667H7.99984Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrideyeIcons);
export default __webpack_public_path__ + "static/media/grideye_icons.07f4297d14368623920c36b95286eec3.svg";
export { ForwardRef as ReactComponent };